import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "font-medium text-2xl" }
const _hoisted_3 = { class: "text-sm text-[#5f6980]" }
const _hoisted_4 = ["src"]

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceShowcase',
  props: {
  service: {
    type: String,
    required: true,
  },
  reverse: {
    type: Boolean,
    required: false,
  },
},
  setup(__props) {

const props = __props;

const currentUrl = new URL(import.meta.url);

const template: { [key: string]: { title: string; body: string; iconName: string } } = {
  cleaning: {
    title: 'Cleaning Services',
    body: 'Enjoy hassle-free cleaning. From laundry to deep cleaning, we keep your space spotless.',
    iconName: 'cleaning-service-icon.png',
  },
  rental: {
    title: 'Apartment Rental',
    body: 'Find the perfect student apartment in London quickly and easily with TALAB.',
    iconName: 'apartment-service-icon.png',
  },
  university: {
    title: 'University Assistance',
    body: 'Get help with your academic needs, from tutoring to administrative support.',
    iconName: 'university-service-icon.png',
  },
  booking: {
    title: 'Clubs and Bars Booking',
    body: 'Book the best clubs and bars in London and enjoy exclusive deals.',
    iconName: 'club-service-icon.png',
  },
  chauffeur: {
    title: 'Chauffeur Services',
    body: 'Ride comfortably and safely with our professional chauffeur services.',
    iconName: 'driver-service-icon.png',
  },
  personal: {
    title: 'Personal Services',
    body: 'Personal assistants ready to help with errands, appointments, and more.',
    iconName: 'private-service-icon.png',
  },
};

function getImagePath(path: string) {
  // eslint-disable-next-line global-require
  return require(`@/assets/${path}`);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-center gap-5 lg:flex-row", {'flex-row-reverse' : !__props.reverse}])
  }, [
    (__props.reverse)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: getImagePath(template[__props.service].iconName),
          class: "size-16",
          alt: ""
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["w-80", { 'text-left': __props.reverse, 'text-left md:text-right' : !__props.reverse }])
    }, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(template[__props.service].title), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(template[__props.service].body), 1)
    ], 2),
    (!__props.reverse)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: getImagePath(template[__props.service].iconName),
          class: "size-16",
          alt: ""
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true)
  ], 2))
}
}

})